module.exports = __webpack_public_path__ + "img/brand.7fb69ecc.svg";